/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdditionalInformationInner } from './additionalInformationInner';
import { SalesProduct } from './salesProduct';

/**
 * Returns all calculated prices.   The prices are embedded into the *salesProduct* object.   The final contract agreement and PDF documents are sent later on to the B2C customer.
 */
export interface OrderResponse {
  salesProduct?: SalesProduct;
  /**
   * Verti generated and unique contract number.   (german: Vertragsnummer)
   */
  contractNumber?: string;
  /**
   * Additional information concerning the response.
   */
  additionalInformation?: Array<AdditionalInformationInner>;
}
